import { useCallback, useMemo } from "react";
import useNetwork from "../common/hooks/networkHook";
import { addJobRelation, removeJobRelation, useRelatedJobs } from "../reducers/jobRelationSlice";
import { useSelectedJobid } from "../utils/CADStateProvider";
import JobTable from "./JobTable";
import PropTypes from 'prop-types';
import { checkEnabled } from "../utils/enableUtilities";
import useClientConfig from "../common/hooks/clientConfigHook";

const canSelect = () => true

const JobRelations = ({ jobid, disabled }) => {
    const network = useNetwork();
    const clientConfig = useClientConfig();
    const relatedJobs = useRelatedJobs(jobid);
    const { setSelectedJobId } = useSelectedJobid();

    const jobs = useMemo(() => relatedJobs.map(r => r.relatedid), [relatedJobs]);
    const exclude = useMemo(() => [jobid], [jobid]);
    const searchFilter = useCallback((j) => checkEnabled(clientConfig, clientConfig.jobLinking, j) , [clientConfig]);
    const handleSelect = useCallback(job => setSelectedJobId(job.jobid), [setSelectedJobId]);
    const handleAdd = useCallback(job => addJobRelation(network, { jobid, relatedid: job.jobid}), [jobid, network]);
    const handleRemove = useCallback(job => removeJobRelation(network, { jobid, relatedid: job.jobid }), [jobid, network]);

    return <JobTable jobs={jobs} exclude={exclude} searchFilter={searchFilter} disabled={disabled} canSelect={canSelect} onSelect={handleSelect} onAdd={handleAdd} onRemove={handleRemove}></JobTable>
}
JobRelations.propTypes = {
    jobid: PropTypes.string,
    disabled: PropTypes.bool
}
export default JobRelations;